import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 自动import modules下的文件
const modulesFiles = require.context('./modules', true, /\.js$/)

const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

const getters = {
  backend: state => state.login.backend,
  support: state => state.login.support,
  channel_names: state => state.login.channel_names
}

const store = new Vuex.Store({
  modules,
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js